module.exports = __webpack_public_path__ + "static/img/cnc5.b386648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/cnc5.jpg
// module id = hyFi
// module chunks = 2